<template>
  <div
    class="relative"
    :content="isDisabled ? 'Não é possível alternar contas durante a edição de parâmetros' : 'Alternar contas'"
    v-tippy="{
      arrow: true,
      theme: isDisabled ? 'red' : 'green',
      boundary: 'window',
    }"
  >
    <button
      @click="toggleSelect = !toggleSelect"
      type="button"
      class="w-full px-6 py-3"
      v-if="accountTypes.accounts.length > 0 && mobile"
    >
      <div class="flex justify-center">
        <span
          v-html="itemLogo(accountTypes.selectedAccount.broker_name, accountTypes.selectedAccount.account_type)"
        ></span>
        <!-- <span class="text-[9px] text-gray-300 text-center top-[34px] absolute">
     {{ accountTypes.selectedAccount.broker_name }}</span
    > -->
      </div>
    </button>
    <button
      :disabled="isDisabled"
      @click.stop="toggleSelect = !toggleSelect"
      type="button"
      :class="[
        styles.optionButton,
        mobile ? 'bg-ontick-graphite-500 px-2 py-1' : 'bg-ontick-steel-600 inline-flex px-3 py-2',
      ]"
      class="border-ontick-graphite-500 disabled:cursor-not-allowed disabled:bg-gray-600"
      v-if="accountTypes.accounts.length > 0 && !mobile"
    >
      <div class="inline-flex justify-center" :class="minimize ? 'mr-3' : 'mr-0'">
        <div
          class="h-6 w-6 min-w-6 min-h-6"
          v-html="itemLogo(accountTypes.selectedAccount.broker_name, accountTypes.selectedAccount.account_type)"
        ></div>
      </div>
      <div v-show="minimize" class="text-gray-200">
        #{{ accountTypes.selectedAccount.account_number }}
        <!-- <span class="text-gray-400 group-hover:text-white ml-1 text-xs"
     >(#{{ accountTypes.selectedAccount.account_number }})</span
    > -->
      </div>

      <span
        content="Estratégias em execução"
        v-tippy="{ arrow: true, theme: 'green' }"
        class="relative ml-auto flex items-center pr-2"
        v-show="minimize"
      >
        <div
          v-show="getRunningInvestmentsNumber > 0"
          class="bg-ontick-green-500 absolute mr-3 inline-flex h-3 w-3 animate-ping rounded-full opacity-75"
        ></div>

        <div
          class="h-3 w-3 rounded-full"
          :class="getRunningInvestmentsNumber == 0 ? 'bg-gray-400' : 'bg-ontick-green-500'"
        ></div>
        <span class="mx-1 text-white">{{ getRunningInvestmentsNumber }}</span>
      </span>
      <span
        v-show="minimize"
        :class="theme.class"
        class="inline-flex items-center rounded px-2 py-1 text-xs font-semibold"
        :content="theme.tooltip"
        v-tippy="{ arrow: true, theme: 'green' }"
      >
        {{ accountTypes.selectedAccount.account_type.charAt(0) }}
      </span>
      <svg
        class="ml-2 h-5 w-5 transform text-gray-400 transition-transform duration-100 ease-in-out"
        v-show="minimize"
        :class="toggleSelect ? 'rotate-0' : 'rotate-180'"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <transition
      enter-active-class="transform transition duration-300 ease-custom"
      enter-class="translate-y-1/2 scale-y-0 opacity-0"
      enter-to-class="-translate-y-0 scale-y-100 opacity-100"
      leave-active-class="-transform transition duration-300 ease-custom"
      leave-class="-translate-y-0 scale-y-100 opacity-100"
      leave-to-class="translate-y-1/2 scale-y-0 opacity-0"
    >
      <ul v-show="toggleSelect" :class="[styles.boxSelect, minimize ? 'left-6' : 'left-16', 'max-h-[600px]']">
        <li
          v-click-outside="hide"
          v-for="(item, key) in accountTypes.accounts"
          :key="key"
          class="truncate filter transition-all first:rounded-t-md last:rounded-b-md hover:brightness-125"
          :class="[accountTypes.selectedAccount.account_number == item.account_number ? styles.active : styles.option]"
          @click.stop="optionSelected(item)"
        >
          <div class="mr-3 w-[24px] h-[24px] flex" v-html="itemLogo(item.broker_name, item.account_type)"></div>
          <span class="inline-flex items-center pr-3">
            {{ item.broker_name }}
            <span class="ml-2 text-xs text-gray-300 group-hover:text-white">(#{{ item.account_number }}) </span>
          </span>

          <span
            content="Estratégias em execução"
            v-tippy="{ arrow: true, theme: 'green' }"
            class="relative ml-auto flex items-center pr-2"
            v-show="minimize"
          >
            <div
              v-show="item.num_running > 0"
              class="bg-ontick-green-500 absolute mr-3 inline-flex h-3 w-3 animate-ping rounded-full opacity-75"
            ></div>

            <div
              class="h-3 w-3 rounded-full"
              :class="item.num_running == 0 ? 'bg-gray-400' : 'bg-ontick-green-500'"
            ></div>
            <span class="mx-1 text-white">{{ item.num_running }}</span>
          </span>

          <span
            :class="setTheme(item.account_type).class"
            class="inline-flex items-center rounded px-2 py-1 text-xs font-semibold"
            v-tippy="{ arrow: true, theme: 'green' }"
            :content="setTheme(item.account_type).tooltip"
          >
            {{ item.account_type.charAt(0) }}
          </span>
        </li>
        <li class="sticky bottom-0">
          <button
            @click="active = !active"
            class="bg-ontick-steel-500 flex w-full items-center space-x-2 py-3 px-3 text-xs font-medium text-gray-300 filter transition-all hover:brightness-125"
          >
            <span class="text-ontick-blue-500" v-html="$icons.plus"></span>
            <span>Adicionar uma nova conta</span>
          </button>
        </li>
      </ul>
    </transition>
    <modal-account @close="active = false" v-if="active" :active="active" />
  </div>
</template>

<script>
import EventBus from "@/app/shared/utils/event_bus";
import modalAccount from "../modal-account/modal.component";
import ClickOutside from "vue-click-outside";
import { mapActions, mapGetters } from "vuex";
import NotificationAccountComponent from "../../../modules/notification/components/notification-account.component.vue";

export default {
  directives: {
    ClickOutside,
  },

  components: { modalAccount, NotificationAccountComponent },

  props: {
    minimize: {
      type: Boolean,
      default: false,
    },
    mobile: {
      type: Boolean,
    },
  },

  data() {
    return {
      tempParams: {},
      active: false,
      toggleSelect: false,
      optionDefault: null,
      styles: {
        active:
          " border-ontick-blue-900 bg-ontick-graphite-500 text-gray-300 flex items-center px-3 py-2 text-sm filter",
        option:
          "bg-ontick-steel-600 w-full xl:w-full text-gray-300 flex items-center px-3 py-2 text-sm hover:bg-ontick-steel-500",
        boxSelect:
          "overflow-x-hidden z-40 cursor-pointer bottom-12 border-ontick-carbon-500 border origin-top-right absolute mt-0 rounded-md shadow-lg bg-ontick-steel-700",
        optionButton:
          "w-full items-center justify-center border-b-2 shadow-sm text-sm font-medium text-gray-200 focus:outline-none",
      },
    };
  },

  computed: {
    ...mapGetters({
      accountTypes: "accountTypes/getAccountTypes",
      selectedAccount: "accountTypes/getSelectedAccount",
      getRunningInvestmentsNumber: "investment/getRunningInvestmentsNumber",
    }),
    theme() {
      return this.setTheme(this.selectedAccount.account_type);
    },
    isDisabled() {
      return this.$route.name === "Editar investimentos";
    },
  },

  methods: {
    ...mapActions({
      updateAccount: "accountTypes/updateAccount",
    }),
    setTheme(type) {
      switch (type) {
        case "DEMO":
          return {
            class: "bg-gray-500 text-gray-200",
            tooltip: "Conta Demo",
          };
        case "PRD":
          return {
            class: "bg-ontick-blue-900 text-ontick-blue-500",
            tooltip: "Conta Produção",
          };
        case "CONTEST":
          return {
            class: "bg-ontick-yellow-900 text-ontick-yellow-500",
            tooltip: "Conta de campeonato",
          };
        default:
          return {
            class: "bg-ontick-blue-900 text-ontick-blue-500",
            tooltip: "Tipo de conta não identificado",
          };
      }
    },
    optionSelected(item) {
      var ehEditInvestment = false;
      if (this.$route.path.split("/").length == 4) {
        var path = this.$route.path.split("/");
        if (path[1] == "investments" && path[3] == "edit") {
          ehEditInvestment = true;
        }
      }
      if (!ehEditInvestment) {
        // Caso não esteja em editar parâmetros, deve atualizar a conta normalmente.
        this.toggleSelect = false;
        let params = { account: item, router: this.$route.path };

        if (this.accountTypes.selectedAccount.account_number != item.account_number) {
          this.updateAccount(params);

          const content = {
            component: NotificationAccountComponent,
            props: {
              id:
                this.accountTypes.selectedAccount.broker_name + " #" + this.accountTypes.selectedAccount.account_number,
              account: this.accountTypes.selectedAccount.account_type,
              title: `Você está usando uma conta ${
                this.accountTypes.selectedAccount.account_type == "DEMO" ? "DEMO" : "PRODUÇÃO"
              }.`,
              message: `Sua troca de contas foi efetuada com sucesso. ${
                this.accountTypes.selectedAccount.account_type == "DEMO" ? " " : "Bons investimentos!"
              }`,
              icons: this.itemLogo(
                this.accountTypes.selectedAccount.broker_name,
                this.accountTypes.selectedAccount.account_type
              ),
            },
          };
          // this.$toast(content, {
          //  bodyClassName: "notification",
          //  toastClassName: "notification",
          //  position: "top-right",
          //  timeout: 5000,
          //  closeOnClick: true,
          //  pauseOnFocusLoss: true,
          //  pauseOnHover: true,
          //  draggable: true,
          //  draggablePercent: 0.6,
          //  showCloseButtonOnHover: false,
          //  closeButtonClassName: "close_button",
          //  hideProgressBar: true,
          //  // closeButton: "button",
          //  icon: false,
          //  rtl: false,
          // });
          this.$swal({
            title: "Conta alterada",
            text: `Você está na conta ${params.account.broker_name}: ${
              item.account_type === "PRD" ? "PRODUÇÃO" : "DEMO"
            }`,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            iconHtml: this.$icons.swal_success,
          });
          EventBus.$emit("CHANGE_ACCOUNT");
        } else {
          this.toggleSelect = false;
          this.tempParams = { account: item, router: this.$route.path };
        }
      }
    },
    hide() {
      this.toggleSelect = false;
    },
    itemLogo(broker_name, account_type) {
      switch (broker_name) {
        case "OnTick":
          return this.$icons.ontick;

        case "XP":
          return this.$icons.xp;

        case "Cripto":
          return this.$icons.bitcoin;

        case "RICO":
          return this.$icons.rico_badge;

        case "CLEAR":
          return this.$icons.clear_light_badge;

        case "XTAGE":
          return this.$icons.xtage_badge;

        case "Campeonato":
          return this.$icons.trophy;
      }
      if (account_type === "CONTEST") {
        return this.$icons.trophy;
      }
    },
  },

  mounted() {
    // Recebe da tela de editar parâmetros.
    // EventBus.$on("ACCOUNT_CHANGE_CONFIRMED", () => {
    //  if (Object.keys(this.tempParams).length > 0)
    //   this.updateAccount(this.tempParams);
    // });
    EventBus.$on("ACTIVE_MODAL", (payload) => (this.active = payload));
  },
};
</script>

<style>
.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}

.Vue-Toastification__toast--default.notification {
  @apply bg-ontick-steel-100 dark:bg-ontick-carbon-600 bg-opacity-90 backdrop-blur-sm backdrop-opacity-90 backdrop-filter dark:bg-opacity-90 dark:backdrop-blur-sm dark:backdrop-opacity-90 dark:backdrop-filter;
}

.close_button {
  @apply bg-ontick-steel-500 inline-flex h-6 w-6 items-center justify-center rounded-full pr-2 text-gray-100;
}
</style>
